<template>
  <div class="admin-request">
    <div class="card-header bg-default">
      <span class="mr-1 fa" :class="typeIcon"></span>
      {{ adminRequest.requestType }}
      <span class="badge" :class="{
        'badge-success': adminRequest.actioned,
        'badge-danger': !adminRequest.actioned,
      }">
        {{ adminRequest.actioned ? 'Resolved' : 'Unresolved' }}
      </span>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item" v-if="adminRequest.Account">
        <span class="mr-1 fa fa-user"></span>
        <router-link :to="`/membership/members/${adminRequest.Account.uuid}`">
          {{ adminRequest.Account.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="adminRequest.Car">
        <span class="mr-1 fa fa-car"></span>
        <router-link :to="`/fleet/vehicles/${adminRequest.Car.uuid}`">
          {{ adminRequest.Car.dropdownLabel }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="adminRequest.Reservation.uuid">
        <span class="mr-1 fa fa-calendar-alt"></span>
        <router-link
        :to="`/fleet/reservations/${adminRequest.Reservation.uuid}`">
          Reservation #{{ adminRequest.Reservation.reservationId }}
        </router-link>
      </li>
      <li class="list-group-item" v-if="adminRequest.actioned && adminRequest.AdminResponsible">
        <span class="mr-1 fas fa-clipboard-check"></span>
        <router-link :to="`/membership/members/${adminRequest.AdminResponsible.uuid}`">
          {{ adminRequest.AdminResponsible.dropdownLabel }}
        </router-link>
      </li>
    </ul>
    <div class="card-body">
      <h6 class="card-subtitle mb-2 text-muted">
        <span class="fa fa-clock"></span> {{ adminRequest.createdAt | date_format('Australia/Melbourne') }}
      </h6>
      <template v-if="adminRequest.requestType === 'Low Fuel Report'">
        <div class="card-text">Low Fuel reported</div>
      </template>
      <template v-if="adminRequest.requestType === 'Reservation Charge'">
        <p class="card-text">Additional charges amounted to more than $200. Admin Approval required.</p>
        <p><strong>Late Fee: </strong> {{ lateFee | to_dollar_amount }}<br>
        <strong>KM Fee: </strong> {{ kmFee | to_dollar_amount }}</p>
      </template>
      <template v-if="adminRequest.requestType === 'High KM'">
        <p class="card-text">Kilometres reported exceed 1000km</p>
        <p><strong>Reported KM: </strong> {{ adminRequest.jsonRequest.km | pretty_number }}km</p>
      </template>
    </div>
    <div class="card-footer text-right">
      <router-link :to="`/follow-up/problems/${adminRequest.uuid}`" class="btn btn-sm btn-primary">
      <span class="fa fa-search"></span>
        View
      </router-link>
    </div>
  </div>
</template>

<script>
import { iconMap } from '@/util/helpers'
export default {
  name: 'AdminRequest',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    typeIcon () {
      for (let key in iconMap.AdminRequest) {
        if (this.adminRequest.requestType.includes(key)) {
          return iconMap.AdminRequest[key]
        }
      }
    },
    lateFee () {
      if (this.adminRequest.Reservation) {
        if (this.adminRequest.Reservation.lateFee !== null) {
          return this.adminRequest.Reservation.lateFee
        } else {
          return this.adminRequest.jsonRequest.lateFee
        }
      } else {
        return 0
      }
    },
    kmFee () {
      if (this.adminRequest.Reservation) {
        if (this.adminRequest.Reservation.kmFee !== null) {
          return this.adminRequest.Reservation.kmFee
        } else {
          return this.adminRequest.jsonRequest.kmFee
        }
      } else {
        return 0
      }
    },
    timezone () {
      if (this.adminRequest.Reservation) {
        return this.adminRequest.Reservation.Lot.timezone
      } else {
        return 'Australia/Melbourne'
      }
    },
    adminRequest () {
      if (!this.object.Reservation) {
        this.object.Reservation = {
          Car: false
        }
      }
      return {
        uuid: '',
        requestType: '',
        jsonRequest: {},
        actioned: false,
        AccountNote: {},
        AdminResponsible: {},
        Car: this.object.Reservation.Car,
        Reservation: {
          Car: {
            CarType: {}
          },
          Lot: {}
        },
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/AdminRequest.vue